import { FieldDefinition, FieldBuilder, MenuCategories, MenuSubcategories, MENU_CATEGORY_KEY, MENU_SUBCATEGORY_KEY, MENU_NAME_SUFFIX } from '@zendra/shared';

FieldBuilder.setNamespace('Planning');

export const DATAORIGIN_FIELDS: FieldDefinition[] = [
  FieldBuilder
    .text('name', 'Entity.DataOrigin.Name')
    .required()
    .minLength(1)
    .maxLength(50)
    .build(),
  FieldBuilder
    .text('code', 'Entity.DataOrigin.Code')
    .minLength(1)
    .maxLength(10)
    .required()
    .build(),
];

export const DATAORIGIN_CONFIG = {
  entityName: 'DataOrigin',
  localizationKey: 'Planning::Entity.DataOrigin',
  fields: DATAORIGIN_FIELDS,
  permission: 'ResearchAndDevelopmentGeneticMaterial.DataOrigins',
  showInMenu: true,
  menuCategory: MENU_CATEGORY_KEY + MenuCategories.ResearchAndDevelopment + MENU_NAME_SUFFIX,
  menuSubcategory: MENU_SUBCATEGORY_KEY + MenuSubcategories.GeneticMaterial + MENU_NAME_SUFFIX,
};
